import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import actions from "../redux/actions";
import apiService from '../utils/api.service';
import helper from '../utils/helper';
import { Button, Modal } from 'antd';
import _ from 'lodash'

const devtool = helper.CONFIG.DEVTOOL
const version = helper.CONFIG.version
const GetConfig = (props) => {
  const getConfig = async () => {
    try {
      const { resData } = await apiService.Profile.SearchConfig()
      if (resData.resultCode === "20000") {
        let resultDataTotal = {}
        console.log('resData getConfig >>', resData.resultData)

        try {
          const res2 = await apiService.Dropdown.DDPosition()
          const resData2 = res2.resData
          if (resData2.resultCode === "20000") {
            resultDataTotal.position = resData2.data ?? []
          }
        } catch(e) {
          console.log('ERR GET Dropdown.DDPosition')
        }
        resultDataTotal = { ...resultDataTotal, ...resData.resultData }
        console.log('resultDataTotal >>', resultDataTotal)
        props.setConfig(resultDataTotal);
      }
    }
    catch(e){
      console.log('API ERR getConfig', e)
    }
  };
  const info = () => {
    Modal.info({
      title: 'Debug',
      content: (
        <div>
          { 
            props.user 
            ? 
            <>
                <p>Version : { version }</p>
                <p>Lineid : { props.user.lineId.lineId }</p>
                <p>memberId : { props.user.lineId.memberId }</p>
                <p>Latitude : { props.location?.latitude }</p>
                <p>Longitude : { props.location?.longitude }</p>
            </>
            : null
          }
        </div>
      ),
      onOk() {},
    });
  };

  useEffect(() => {
    getConfig();
  }, []);

  return (
    <div className={`dev-tool r ${ devtool ? 'active' : '' }`}>
        <Button onClick={info}>CONFIG</Button>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps, actions)(GetConfig);
